export default {
  // Authentication

  PasswordRequestResetScreen: {
    title: "Passwort vergessen",
    explanatoryText:
      "Bitte geben Sie die E-Mail-Adresse Ihres Unternehmer-Accounts ein, " +
      "um Ihr Passwort in weiterer Folge zurückzusetzen.",

    submitLabel: "Zurücksetzung anfordern",
    successPasswordRequest:
      "Zurücksetzung angefordert: " +
      "Sie erhalten in Kürze eine E-Mail mit weiteren Informationen.",
  },

  PasswordResetScreen: {
    title: "Passwort zurücksetzen",
    explanatoryText:
      "Bitte geben Sie ein neues Passwort ein, " +
      "welches aus mindestens 10 Zeichen besteht und eine Zahl, " +
      "einen Groß- und Kleinbuchstaben sowie ein Sonderzeichen beinhaltet.",

    submitLabel: "Passwort ändern",
    successPasswordReset: "Passwort geändert: Sie können sich nun einloggen.",
  },

  // Cash register management

  CashRegisterListScreen: {
    cashRegisterNumber: "Kassennummer",
    pairing: "Verknüpfung",
    pairedWith: "Verknüpft mit {{name}}",
    notPaired: "Nicht verknüpft",
    appVersion: "App-Version",
    lastActive: "Zuletzt aktiv",

    emptyListMessage:
      "Es sind noch keine Kassen vorhanden, bitte kontaktieren Sie den Support.",
    emptyTableMessage: "Es wurden keine Kassen zu diesem Suchbegriff gefunden.",

    unpairDialogTitle: "Verknüpfung aufheben",
    unpairDialogMessage:
      'Möchten Sie die Verknüpfung der "{{cashRegisterName}}" ' +
      'mit dem Gerät "{{pairedDeviceName}}" wirklich aufheben?\n\n' +
      "Nur die Verknüpfung wird aufgehoben. Die Kasse selbst wird nicht gelöscht.\n" +
      'Sie können "{{cashRegisterName}}" danach mit einem neuen Gerät verknüpfen.',
    unpairDialogConfirmLabel: "Aufheben",

    successUnpairMessage:
      'Verknüpfung mit "{{name}}" wurde erfolgreich aufgehoben.',
    unpairedDialogMessage:
      'Bitte löschen Sie nun die MAX&BEN-App vom entknüpften Gerät "{{name}}".',
  },
  CashRegisterEditScreen: {
    terminalId: "Terminal-ID",
    terminalPassword: "Terminal-Passwort",
    terminalIP: "Terminal-IP-Adresse",
    terminalPort: "Terminal-Port",
    nameOfPrinter: "Name des Druckers",
    integration: "Anbindung",
    drawerDevice: "Kassenlade",
    receiptDesign: "Bon-Belegdesign",
    a4ReceiptDesign: "A4-Belegdesign",
    deviceLog: "Gerätelog",
    cardPayment: "Kartenzahlung",
    printerName: "Druckername",
    displayName: "Anzeigename",
    defaultPrinter: "Standarddrucker",
    paperCutter: "Papierabschneider",
    pairedWith: "Verknüpft mit {{name}}",

    chooseAPrinterPlaceholder: "Wählen Sie einen Drucker aus...",
    gpTomTooltip:
      "Um die GP tom Anbindung nützen zu können, müssen Sie sowohl " +
      "die GP tom App als auch die GP tom PIN App auf Ihrem Kassengerät installiert haben.",

    defaultPrinterChangeSuccess:
      'Der Drucker "{{name}}" wurde als neuer Standarddrucker festgelegt.',
    cashRegisterEditSuccess:
      'Die Einstellungen der "Kasse {{number}}" wurden erfolgreich bearbeitet.',
  },

  DrawerModeEditScreen: {
    title: "Tagesanfangsstand",
    modeTitle: "Bestandsmodus",
    fixed: "Fixer Anfangsbestand",
    openingBalance: "Anfangsbestand",
    continuous: "Endbestand letzte Abrechnung",

    originOperator: "diesen Bediener",
    originCashRegister: "diese Kasse",
    originOperatorBillingReport: "Bedienerabrechnung",
    originCashRegisterBillingReport: "Kassenabrechnung",
    buttonTooltip:
      "Der Tagesanfangsstand kann im Moment nicht für " +
      "{{origin}} konfiguriert werden. Bitte konfigurieren Sie diesen in der {{management}}. " +
      "Die globale Abrechnungsart ist auf {{billingReportMode}} eingestellt.",

    successChangeMessage:
      'Die Tagesanfangsstand-Konfiguration für "{{name}}" wurde erfolgreich bearbeitet.',
  },

  CashRegisterA4ReceiptDesignScreen: {
    title: "A4-Belegdesign",
    newDraft: "Neuer Entwurf",
    graphic: "Grafik",
    size: "Größe",
    sideLayoutTitle: "Seitenränder",
    sideLayoutTooltip: "Die Seitenmaße werden in Zentimeter (cm) angegeben.",
    topEdge: "Oberkante",
    bottomEdge: "Unterkante",
    headerEntriesHeading: "Belegkopf",
    footerEntriesHeading: "Fußzeilen",
    letterHeadMode: "Briefkopfmodus",
    extraSettingsPlaceholder: "Grafik & Seitenränder",
    missingImageMessage:
      "Es wurde noch keine Grafik hochgeladen oder gespeichert.",

    taxId: "UID: {{taxId}}",
    exampleArticle: "Musterartikel",
    articleDiscount: "Artikelrabatt",
    givenCash: "Gegeben Bar",
    givenVoucher: "Gegeben Gutschein",
    returnCash: "Rückgeld Bar",
    thanksForShopping: "Vielen Dank für Ihren Besuch / Einkauf!",
    taxOfficeCashBoxId: "Kassen-ID: {{taxOfficeCashBoxId}}",
    welcomeToMaxAndBen:
      "Willkommen bei Max&Ben - Die Registrierkasse mit persönlicher Betreuung!",
    johnDoe: "Max Mustermann",

    headerEntriesTooltip:
      "Werden Zeilen des Belegkopfes farblich hervorgehoben, " +
      "so werden diese Zeilen am A4-Beleg abgeschnitten, " +
      "sollte der Beleg an einen Kunden adressiert sein.",
    imageDimensionTooltip:
      "Werden der Hintergrund oder die Umrandung der Grafik farblich hervorgehoben, " +
      "so kann diese in den Bereich des Adresskopfes hineinragen, " +
      "sollte der Beleg an einen Kunden adressiert sein.",

    headerImageLoadingError:
      "Die Grafik für den {{mode}}Belegkopf konnte nicht geladen werden. " +
      "Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.",
    headerImageUploadSuccess:
      "Die Grafik für den {{mode}}Belegkopf wurde erfolgreich aktualisiert.",
    headerImageUploadError:
      "Upload der neuen Grafik für den {{mode}}Belegkopf fehlgeschlagen. " +
      "Bitte überprüfen Sie den Typ und die Dateigröße (max. 3MB) der Grafik.",
    successDeleteHeaderImageMessage:
      "Die Grafik für den {{mode}}Belegkopf wurde erfolgreich gelöscht.",
    failDeleteHeaderImageMessage:
      "Löschen der bestehenden Grafik für den {{mode}}Belegkopf fehlgeschlagen.",

    noDesignEntriesMessage:
      "Zur Zeit gibt es kein benutzerdefiniertes Design für diesen Teil des Beleges. " +
      'Sie können mit Hilfe der "+"-Schaltfläche einen entsprechenden Entwurf erstellen.',

    confirmCancelMessage:
      "Wenn Sie jetzt abbrechen, gehen alle Änderungen verloren!\n" +
      "Diese sind danach unwiderrufbar!",
    discardChanges: "Änderungen verwerfen",

    confirmDiscardMessage:
      "Wenn Sie dieses Design verwerfen, " +
      "gehen alle Änderungen sowie der aktuelle Entwurf verloren.\n" +
      "Diese Aktion ist unwiderrufbar!",
    discardDesign: "Design verwerfen",

    successEditMessage:
      'Das {{mode}}Belegdesign von "{{name}}" wurde erfolgreich bearbeitet.',
    successDiscardMessage:
      'Das {{mode}}Belegdesign von "{{name}}" wurde erfolgreich verworfen.',
  },
  CashRegisterPhysicalReceiptDesignScreen: {
    title: "Bon-Belegdesign",
    dimensionDialogMessage:
      "Die gewählte Dimension der Grafik, entspricht nicht " +
      "der optimalen Größe für die entsprechende Belegbreite.\n" +
      "Möchten Sie wirklich mit dieser Größe fortfahren?",
    imageContrastTooltip:
      "Sollte Ihre Grafik auf dem Beleg nicht sichtbar sein, " +
      "überprüfen Sie bitte den Kontrast des Bildes. " +
      "Sehr helle Grafiken können Probleme während des Druckvorganges hervorrufen.",
  },

  DeviceLogScreen: {
    title: "Gerätelog",
    lineBreak: "Zeilenumbruch",
    presentation: "Darstellung",
    noLogMessages:
      "Für diese Kasse sind im Moment keine Logmeldungen vorhanden.",
    fileName: "Geraetelog",
  },

  KeyboardLayoutListScreen: {
    articleKeyManagement: "Artikeltastenverwaltung",
    keysGroupManagement: "Tastengruppenverwaltung",

    emptyListMessage:
      "Es sind noch keine Tastaturlayouts vorhanden. Bitte legen Sie ein Tastaturlayout an.",

    deleteDialogTitle: "Tastaturlayout löschen",
    deleteDialogMessage:
      'Möchten Sie das Tastaturlayout "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Das Tastaturlayout "{{name}}" wurde erfolgreich gelöscht.',
  },
  KeyboardLayoutAddScreen: {
    title: "Tastaturlayout anlegen",
    columnCount: "Spaltenanzahl",
    columnCountPortrait: "Hochformat",
    columnCountLandscape: "Querformat",
    assignedCashRegisters: "Zugeordnete Kassen",
    assignmentOfCashRegisters: "Zuordnung von Kassen",
    assignmentOfKeysMainGroups: "Zuordnung von Tastenhauptgruppen",

    successAddMessage:
      'Das Tastaturlayout "{{name}}" wurde erfolgreich angelegt.',
  },
  KeyboardLayoutEditScreen: {
    title: "Tastaturlayout bearbeiten",

    successEditMessage:
      'Das Tastaturlayout "{{name}}" wurde erfolgreich bearbeitet.',
  },

  KeysGroupListScreen: {
    title: "Tastenhaupt- und Tastenuntergruppen",
    keysMainGroupsTitle: "Tastenhauptgruppen",
    keysSubGroupTitle: "Tastenuntergruppen in {{keysMainGroupName}}",

    emptyKeysMainGroupListMessage:
      "Es sind noch keine Tastenhauptgruppen vorhanden. Bitte legen Sie eine Tastenhauptgruppe an.",
    emptyKeysSubGroupListMessage:
      "Für diese Tastenhauptgruppe wurde noch keine Tastenuntergruppe angelegt. " +
      "Bitte legen Sie eine Tastenuntergruppe an.",

    deleteKeysMainGroupDialogTitle: "Tastenhauptgruppe löschen",
    deleteKeysMainGroupDialogMessage:
      'Möchten Sie die Tastenhauptgruppe "{{name}}" wirklich löschen?\n\n' +
      "Diese und alle dazugehörenden Objekte (Tastenuntergruppen sowie Artikeltasten) " +
      "werden aus allen potenziell vorhandenen Tastaturlayouts entfernt.",
    successKeysMainGroupDeleteMessage:
      'Die Tastenhauptgruppe "{{name}}" wurde erfolgreich gelöscht.',

    deleteKeysSubGroupDialogTitle: "Tastenuntergruppe löschen",
    deleteKeysSubGroupDialogMessage:
      'Möchten Sie die Tastenuntergruppe "{{name}}" wirklich löschen?\n\n' +
      "Diese und alle dazugehörenden Objekte (Artikeltasten) " +
      "werden aus allen potenziell vorhandenen Tastaturlayouts entfernt.",
    successKeysSubGroupDeleteMessage:
      'Die Tastenuntergruppe "{{name}}" wurde erfolgreich gelöscht.',

    mainGroupAbbreviation: "HG: {{name}}",
    articleGroupAbbreviation: "WG: {{name}}",
  },

  KeysMainGroupAddScreen: {
    title: "Tastenhauptgruppe anlegen",

    previewTooltip:
      "Die Breite der Tastenhauptgruppe ist fixiert. " +
      "Um eine optimale Darstellung zu garantieren, " +
      "wird die Textlänge der Bezeichnung reglementiert.",

    successAddMessage:
      'Die Tastenhauptgruppe "{{name}}" wurde erfolgreich angelegt.',
  },
  KeysMainGroupEditScreen: {
    title: "Tastenhauptgruppe bearbeiten",

    successEditMessage:
      'Die Tastenhauptgruppe "{{name}}" wurde erfolgreich bearbeitet.',
  },

  KeysSubGroupAddScreen: {
    title: "Tastenuntergruppe anlegen",
    selectArticleKeys: "Artikeltasten zuordnen",
    articleKeyTableTitle: "Zugeordnete Artikeltasten",

    previewTooltip:
      "Die Breite der Tastenuntergruppe ist fixiert. " +
      "Um eine optimale Darstellung zu garantieren, " +
      "wird die Textlänge der Bezeichnung reglementiert.",

    emptyListMessage:
      "Der Tastenuntergruppe wurden noch keine Artikeltasten zugeordnet.",
    emptyTableMessage:
      "Es wurden keine zugeordneten Artikeltasten zu diesen Suchkriterien gefunden.",

    successAddMessage:
      'Die Tastenuntergruppe "{{name}}" wurde erfolgreich angelegt.',
  },
  KeysSubGroupEditScreen: {
    title: "Tastenuntergruppe bearbeiten",

    successEditMessage:
      'Die Tastenuntergruppe "{{name}}" wurde erfolgreich bearbeitet.',
  },

  ArticleKeyListScreen: {
    title: "Artikeltasten",
    articleKeyLineOne: "Zeile 1",
    articleKeyLineTwo: "Zeile 2",
    example: "Beispiel",

    articleSelectionTitle: "Wählen Sie einen Artikel aus...",
    assignmentTooltip:
      "Artikel, welche bereits einer Artikeltaste zugeordnet sind, " +
      "können nicht ein weiteres Mal zugeordnet werden.",
    exampleTooltip:
      "Die Breite der Artikeltasten orientiert sich " +
      "an jener des Kassenendgerätes. " +
      "Deshalb ist die Darstellung der Textzeilen " +
      "rein exemplarisch zu interpretieren.",

    emptyListMessage:
      "Es sind noch keine Artikeltasten vorhanden. " +
      "Bitte legen Sie eine Artikeltaste an oder " +
      "lassen Sie diese über die Tastengruppenverwaltung automatisch generieren.",
    emptyTableMessage:
      "Es wurden keine Artikeltasten zu diesem Suchbegriff gefunden.",

    deleteDialogTitle: "Artikeltaste löschen",
    deleteDialogMessage:
      'Möchten Sie die Artikeltaste "{{name}}" wirklich löschen?\n\n' +
      "Ist diese Taste Teil einer Tastenuntergruppe oder eines Tastaturlayouts, " +
      "wird diese auch aus diesen gelöscht.",
    successDeleteMessage:
      'Die Artikeltaste "{{name}}" wurde erfolgreich gelöscht.',
  },
  ArticleKeyAddScreen: {
    title: "Artikeltaste anlegen",

    successAddMessage:
      'Die Artikeltaste "{{name}}" wurde erfolgreich angelegt.',
  },
  ArticleKeyEditScreen: {
    title: "Artikeltaste bearbeiten",

    successEditMessage:
      'Die Artikeltaste "{{name}}" wurde erfolgreich bearbeitet.',
  },

  CashRegisterSystemConfigurationScreen: {
    dailyAt: "Täglich um",
    closeOfDayTimeTooltip:
      "Wird eine sich in der Vergangenheit befindliche Tageszeit gewählt " +
      "oder wurde der Tagesabschluss für den aktuellen Tag bereits durchgeführt, " +
      "wird der Tagesabschluss am nächsten Tag zur eingestellten Zeit ausgeführt.",

    reportVariant: "Abrechnungsart",
    cashRegisterSpecific: "kassenspezifische",
    operatorSpecific: "bedienerspezifische",
    linkLabelMessage:
      "Klicken Sie hier um {{specific}} Einstellungen zu treffen.",
    reportVariantTooltip: "Abrechnungen erfolgen je {{variant}}",

    successChangeTimeMessage:
      "Der globale Zeitpunkt des täglichen Kassenabschlusses wurde erfolgreich auf {{time}} Uhr geändert.",
    successChangeApproachMessage:
      'Die globale Abrechnungsart wurde erfolgreich zu "{{variant}}" geändert.',
  },

  // Master data management

  MainGroupScreen: {
    emptyListMessage:
      "Es sind noch keine Hauptgruppen vorhanden. Bitte legen Sie eine Hauptgruppe an.",

    orderIndexChanged:
      "Die Sortierreihenfolge der Hauptgruppen wurde geändert.",

    deleteDialogTitle: "Hauptgruppe löschen",
    deleteDialogMessage:
      'Möchten Sie die Hauptgruppe "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Die Hauptgruppe "{{name}}" wurde erfolgreich gelöscht.',
  },
  MainGroupAddScreen: {
    title: "Hauptgruppe anlegen",

    successAddMessage:
      'Die Hauptgruppe "{{name}}" mit Steuergruppe "{{taxRate}}%" wurde erfolgreich angelegt.',
  },
  MainGroupEditScreen: {
    title: "Hauptgruppe bearbeiten",

    confirmEditDialogMessage:
      "Das Anpassen der Steuergruppe wirkt sich auf alle zugeordneten Warengruppen und Artikel aus.\n" +
      "Möchten Sie wirklich mit dieser Anpassung fortfahren?",

    successEditMessage:
      'Die Hauptgruppe "{{name}}" mit Steuergruppe "{{taxRate}}%" wurde erfolgreich bearbeitet.',
  },

  ArticleGroupScreen: {
    articleGroupsIn: "Warengruppen in {{name}}",

    emptyListMessage:
      "Für diese Hauptgruppe wurde noch keine Warengruppe angelegt. Bitte legen Sie eine Warengruppe an.",

    orderIndexChanged:
      "Die Sortierreihenfolge der Warengruppen wurde geändert.",

    deleteDialogTitle: "Warengruppe löschen",
    deleteDialogMessage:
      'Möchten Sie die Warengruppe "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Die Warengruppe "{{name}}" wurde erfolgreich gelöscht.',
  },
  ArticleGroupAddScreen: {
    title: "Warengruppe anlegen",

    successAddMessage:
      'Die Warengruppe "{{name}}" mit Steuergruppe "{{taxRate}}%" wurde erfolgreich angelegt.',
  },
  ArticleGroupEditScreen: {
    title: "Warengruppe bearbeiten",

    confirmEditDialogMessage:
      "Das Anpassen der Steuergruppe wirkt sich auf alle zugeordneten Artikel aus.\n" +
      "Möchten Sie wirklich mit dieser Anpassung fortfahren?",

    successEditMessage:
      'Die Warengruppe "{{name}}" mit Steuergruppe "{{taxRate}}%" wurde erfolgreich bearbeitet.',
  },

  ArticleListScreen: {
    grossPrice: "VKP",
    fileName: "Artikelliste",

    emptyListMessage:
      "Es sind noch keine Artikel vorhanden. Bitte legen Sie einen Artikel an.",
    emptyTableMessage:
      "Es wurden keine Artikel zu diesem Suchbegriff gefunden.",

    deleteDialogTitle: "Artikel löschen",
    deleteDialogMessage:
      'Möchten Sie den Artikel "{{name}}" wirklich löschen?\n\n' +
      "Ist dieser Artikel einer Artikeltaste zugeordnet, " +
      "so wird auch diese gelöscht und damit aus sämtlichen Tastenuntergruppen sowie Tastaturlayouts entfernt.",
    successDeleteMessage: 'Der Artikel "{{name}}" wurde erfolgreich gelöscht.',
  },
  ArticleAddScreen: {
    title: "Artikel anlegen",

    barcodeNumber: "Barcode",
    assignedBarcodeNumbers: "Zugeordnete Barcodes",
    noBarcodeAssigned: "Es wurde noch kein Barcode zugeordnet.",
    removeExistingAttribution: "Zuordnung aufheben",
    removeCurrentBarcode: "Barcode löschen",
    removeCurrentArticleNumber: "Artikelnummer löschen",

    placeholderMainGroup: "Wählen Sie eine Hauptgruppe aus...",
    placeholderArticleGroup: "Wählen Sie eine Warengruppe aus...",

    grossPrice: "VKP (Brutto)",

    zeroPriceAllowed: "Nullpreis erlaubt",
    zeroPriceAllowedTooltip: "Der Preis darf auch mit 0,00 eingebucht werden.",
    negativePrice: "Negativer Preis",
    negativePriceTooltip: "Der eingegebene Preis soll immer negativ sein.",
    discountBlocked: "Rabattsperre",
    discountBlockedTooltip: "Dieser Artikel soll für Rabatte gesperrt sein.",
    detailsDirectAccess: "Detailabfrage",
    detailsDirectAccessTooltip:
      "Wird dieser Artikel berührt, so soll der Bediener direkt zu den Artikeldetails gelangen.",

    successAddMessage: 'Der Artikel "{{name}}" wurde erfolgreich angelegt.',
  },
  ArticleEditScreen: {
    title: "Artikel bearbeiten",

    successEditMessage: 'Der Artikel "{{name}}" wurde erfolgreich bearbeitet.',
  },

  DiscountListScreen: {
    emptyListMessage:
      "Es sind noch keine Rabatte vorhanden. Bitte legen Sie einen Rabatt an.",

    deleteDialogTitle: "Rabatt löschen",
    deleteDialogMessage: 'Möchten Sie den Rabatt "{{name}}" wirklich löschen?',
    successDeleteMessage: 'Der Rabatt "{{name}}" wurde erfolgreich gelöscht.',
  },
  DiscountAddScreen: {
    title: "Rabatt anlegen",
    variant: "Variante",
    discountValue: "Rabattwert",

    successAddMessage: 'Der Rabatt "{{name}}" wurde erfolgreich angelegt.',
  },
  DiscountEditScreen: {
    title: "Rabatt bearbeiten",

    successEditMessage: 'Der Rabatt "{{name}}" wurde erfolgreich bearbeitet.',
  },

  // Operator management

  OperatorListScreen: {
    emptyListMessage:
      "Es sind noch keine Bediener vorhanden. Bitte legen Sie einen Bediener an.",
    emptyTableMessage:
      "Es wurden keine Bediener zu diesem Suchbegriff gefunden.",
  },
  OperatorAddScreen: {
    title: "Bediener anlegen",

    permissionsHeading: "Bedienerrechte",
    permissionDiscount: "Rabatt erlaubt",
    permissionMaxDiscount: "Max. Rabatt",
    permissionManagement: "Verwaltung erlaubt",
    permissionReportAccess: "Berichte erlaubt",

    permissionDiscountToolTip:
      "Der Bediener darf an der Kasse Rabatte vergeben.",
    permissionManagementToolTip:
      "Der Bediener darf an der Kasse Verwaltungsaufgaben (bspw. Kundenverwaltung) durchführen.",
    permissionReportAccessToolTip:
      "Der Bediener darf an der Kasse Berichte (Zwischenbericht & Abrechnung) einsehen sowie abschließen.",

    featureHeading: "Funktionen",
    featureInstantReceipt: "Sofortbeleg",
    featureInstantReceiptToolTip:
      "Ist diese Funktion aktiv, so führen die Zahlungsarten im Warenkorb " +
      "zu einem sofortigen Belegabschluss.",

    successAddMessage: 'Der Bediener "{{name}}" wurde erfolgreich angelegt.',
  },
  OperatorEditScreen: {
    title: "Bediener bearbeiten",

    successEditMessage: 'Der Bediener "{{name}}" wurde erfolgreich bearbeitet.',
  },

  // Reports

  GroupReportScreen: {
    title: "Haupt- und Warengruppenbericht",
    mainGroupTitle: "Hauptgruppenbericht",
    articleGroupTitle: "Warengruppenbericht",

    groupsToggle: "Warengruppen anzeigen",
    groupsToggleTip:
      "Wird diese Checkbox deselektiert, werden nur mehr Hauptgruppen ausgewertet.",
  },
  CashFlowReportScreen: {
    cashFlowType: "Geldbewegungsart",

    showDetailedLabel: "Detailliert anzeigen",
    showDetailedTooltip:
      "Wird diese Checkbox selektiert, " +
      "wird jede einzelne Bewegung inklusive Datum / Uhrzeit und Bemerkung dargestellt.",

    emptyTableMessage:
      "Es konnten keine Geldbewegungen in dem angegebenen Zeitraum ermittelt werden.",
  },
  CashRegisterLedgerReportScreen: {
    receiptNumber: "B-Nummer",
    discount: "Rabatt % (€)",
  },
  EndOfDayReportScreen: {
    closeDay: "Tagesabschluss durchführen",
    closedAtLabel: "durchgeführt am {{date}}",

    incomeOfToday: "Tagesumsatz",
    emptyTableMessage: "Für diesen Tag wurde kein Umsatz gefunden.",

    closed: "Abschluss",
    openedAt: "Eröffnet am",
    updatedAt: "Aktualisiert am",
    closedAt: "Abgeschlossen am",

    closeDayDialogMessagePartOne:
      "Möchten Sie den Tagesabschluss für den Abrechnungstag",
    closeDayDialogMessagePartTwo: "wirklich durchführen?",
    closeDayDialogMessagePartThree:
      "Die Durchführung eines Tagesabschlusses führt dazu, " +
      "dass alle offenen Abrechnungen und damit auch der Abrechnungstag abgeschlossen werden.",
    closeDayDialogConfirm: "Durchführen",
    successClosedDay:
      'Tagesabschluss für den Abrechnungstag "{{date}}" erfolgreich durchgeführt.',
  },

  // Protocols

  CashRegisterProtocolScreen: { title: "Kassenprotokoll" },
  ManagerProtocolScreen: { title: "Verwaltungsprotokoll" },

  // RKSV

  RksvDataScreen: {
    title: "RKSV-FinanzOnline",
    fonData: "RKSV-FON-Daten",
    taxOfficeCashBoxId: "Kassenidentifikationsnummer",
    aesKey: "Benutzerschlüssel AES-256",
    aesCheckValue: "Prüfwert des Benutzerschlüssels",
    typeOfSafetyMeasurementLabel: "Art der Sicherheitseinrichtung",
    typeOfSafetyMeasurementValue:
      "Hardware-Sicherheitsmodul (HSM) eines Dienstleisters",
    trustSupplierLabel: "Vertrauensdienstanbieter",
    trustSupplierValue: "AT1 A-TRUST",
    certificateSerialNumber: "Zertifikatsseriennummer",

    copiedToClipboard: "Text wurde in die Zwischenablage kopiert.",

    sendByMailDialogTitle: "RKSV-FON-Daten per E-Mail versenden",
    successSendMessage: 'Die RKSV-FON-Daten wurden an "{{email}}" versendet.',
  },
  RksvExportScreen: {
    title: "RKSV-Export",
    exportAsDep7Title: "Datenerfassungsprotokoll (DEP7)",
    dataCaptureProtocol: "Datenerfassungsprotokoll",
    exportAs131Title: "Kassenjournal (§131)",
    cashRegisterJournal: "Kassenjournal",

    rksvDeactivatedTitle: "RKSV deaktiviert",
    rksvDeactivatedMessage:
      "Die RKSV / Fiskalisierung Ihres Unternehmens ist inaktiv.\n" +
      "Bitte kontaktieren Sie den Support, um diese zu aktivieren.",
  },
  RksvReceiptListScreen: {
    title: "RKSV-Belege",
    rksvReceiptList: "RKSV-Belegliste",

    receiptType: "Belegart",
    automaticallyGenerated: "Automatisch generiert",

    sendByMailDialogTitle: "RKVS-Belegliste per E-Mail versenden",
    successSendMessage: 'Die RKSV-Belegliste wurde an "{{email}}" versendet.',
  },
} as const
